<template>
    <div class="app-container">
    </div>
</template>

<script>

import { ronDecrypt } from '../../utils'

const RTYPE_MAPPING = {
    notice: 'notice',
    event: 'activity',
    update: 'update',
}

export default {
    name: "News",
    data() {
        return {
        };
    },
    methods: {
    },
    beforeMount() {
        if (this.$route.query.s) {
            let id = ronDecrypt(this.$route.query.s)
            this.$router.replace(
                '/recent/' + RTYPE_MAPPING[this.$route.params.rType]
                + '/' + id)
        }
        else
            this.$router.replace('/recent/' + RTYPE_MAPPING[this.$route.params.rType])
    },
    mounted () {
    },
};
</script>

<style scoped>
</style>
